import apiClient from '../apiClient';
import { trackPromise } from 'react-promise-tracker';
import { offlineGet } from '../helpers/offlineHelpers';

async function listDownTimeTypes() {
    const { data } = await trackPromise(apiClient.get('/api/downTimeType/getAll'));
    return data?.data ?? [];
}

async function listEnabledDownTimeTypes() {
    // const { data } = await trackPromise(apiClient.get('/api/downTimeType/enabled'));
    // return data?.data ?? [];
    return offlineGet(
        'downTimeTypes-enabled',
        () => trackPromise(apiClient.get('/api/downTimeType/enabled')),
        (response) => response?.data?.data ?? []
    );
}

async function getDownTimeTypeById(id) {
    const { data } = await trackPromise(apiClient.get(`/api/downTimeType/getById/${id}`));
    return data?.data ?? null;
}

async function createDownTimeType(payload) {
    const { data } = await trackPromise(apiClient.post('/api/downTimeType/add/', payload));
    return data;
}

async function updateDownTimeType(id, payload) {
    const { data } = await trackPromise(apiClient.put(`/api/downTimeType/updateById/${id}`, payload));
    return data;
}

async function toggleDownTimeType(id) {
    const { data } = await trackPromise(apiClient.put(`/api/downTimeType/enabledDisable/${id}`));
    return data;
}

const downtimeService = {
    listDownTimeTypes,
    listEnabledDownTimeTypes,
    getDownTimeTypeById,
    createDownTimeType,
    updateDownTimeType,
    toggleDownTimeType
};

export default downtimeService;
